import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ContentRoutes from "../../routes/ContentRoutes";
import Header from "./Header";
import Imprimir from "../../pages/app/Imprimir";

const logo = require('../../assets/img/logoF-100.png');

const PageWrapper = () => {
    const [showSubMenu, setShowSubMenu] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleSubMenu = () => {
        setShowSubMenu(!showSubMenu);
    };

    const handleSession = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('logged_user');
        navigate('/');
    }

    const handleImprimir = () => {
        <Imprimir />
    }

    return (
        <div id="">
            <div id="sidebar" className="sidebar-menu">
                <header>
                    <img style={{ marginLeft: 'auto', marginRight: 'auto' }} src={logo} alt="Empresa Eléctrica Quito" />
                </header>
                <ul className="sidebar sidebar-menpu">
                    <li
                        className={location.pathname === "/perfil" ? "links-active" : "links"}
                        onClick={() => navigate("/hojadevida/perfil")}
                    >
                        <span>
                            <i className="fa fa-user-o" aria-hidden="true"></i>
                        </span>
                        Perfil
                    </li>
                    <li className={location.pathname === "/" ? "links-active" : "links"} onClick={toggleSubMenu}>
                        <span>
                            <i className="fa fa-file" aria-hidden="true"></i>
                        </span>
                        Hoja de vida
                    </li>
                    {showSubMenu && (
                        <ul className="sub-menu">
                            <li className="ms-5 d-flex align-items-center">
                                <Link to="/inicio" className="d-flex align-items-center">
                                    <span>
                                        <i className="fa fa-info" aria-hidden="true" ></i>
                                    </span>
                                    <span className="ms-2">Información</span> {/* Agrega una clase "ms-2" para agregar un margen a la izquierda del texto */}
                                </Link>
                            </li>
                            <li className="ms-5 d-flex align-items-center">
                                <Link to="/hojadevida/personales" className="d-flex align-items-center">
                                    <span>
                                        <i className="fa fa-university" aria-hidden="true"></i>
                                    </span>
                                    <span className="ms-2">Detalle Informacion</span> {/* Agrega una clase "ms-2" para agregar un margen a la izquierda del texto */}
                                </Link>
                            </li>
                        </ul>

                    )}
                    <li className="links" onClick={() => handleImprimir()}>
                        <Link to="/hojadevida/imprimir" className="d-flex align-items-center">
                            <span>
                                <i className="fa fa-print" aria-hidden="true"></i>
                            </span>
                            <span className="ms-2">Imprimir</span>
                        </Link>
                    </li>
                    <li className="links" onClick={() => handleSession()}>
                        <span>
                            <i className="fa fa-sign-out" aria-hidden="true"></i>
                        </span>
                        Cerrar Sesión
                    </li>
                </ul>
            </div>
            <div id="content">
                <div className="banner-main-sidebar content-header ">
                    <Header />
                </div>
                <div className="content">
                    <ContentRoutes />
                </div>
            </div>
        </div>
    );
};

export default PageWrapper;
